import React from 'react';
import Empleados from './componentes/Empleados/paginaEmpleados';
import Calendario from './componentes/Calendario/Calendario';
import Asistencia from './componentes/Asistencia';
import Documentos from './paginas/Documentos/index';
import Humedad from './componentes/Humedad/index';
import PTele from './paginas/rangerscreen/rangerscreen';
import Actividades from './paginas/paginaActividades';
import TrabajoHecho from './paginas/paginaTrabajoHecho';
import PPendientes from './paginas/pPendientes';
import Zonas from './componentes/Zonas/pZonas';
import Login from './Login';
import SignUp from './SignUp';
import Logout from './Logout';
import PrivateRoute from "./PrivateRoute";
import Herramientas from './paginas/Herramientas'
import Productos from './paginas/Productos'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import {AuthProvider} from "./Auth";
import Pisca from './paginas/pisca/index';
import Pagos from './paginas/PagosAdmin/PagosAdmin';
import Test from './paginas/test'
import UserPage from './paginas/UserPage/index';
import Inicio from './paginas/Inicio';
import Vales from './paginas/Vales/index';
import Ajustes from './paginas/Ajustes/index';
import NotFound from './paginas/NotFound';
import './App.css';
import AdminAssistant from './componentes/AdminAssistant/AdminAssistant';

function App() {
  return (
  <AuthProvider>
    <div className="App">
      <Router>
        <Switch>
          <Route exact path="/" component={Inicio} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/registro" component={SignUp} />
          <Route exact path="/logout" component={Logout} />
          <PrivateRoute path="/Zonas" component={Zonas} roles={['farmAdmin']} />
          <PrivateRoute path="/Pendientes" component={PPendientes} roles={['farmAdmin']} />
          <PrivateRoute path="/Asignados" component={TrabajoHecho} roles={['farmAdmin']} />
          <PrivateRoute path="/Asistencia" component={Asistencia} roles={['farmAdmin']} />
          <PrivateRoute path="/Actividades" component={Actividades} roles={['farmAdmin']}/>
          <PrivateRoute path="/Empleados" component={Empleados} roles={['farmAdmin', 'office']} />
          <PrivateRoute path="/Documentos" component={Documentos} roles={['office']} />
          <PrivateRoute path="/Humedad" component={Humedad} roles={['labInput', 'farmAdmin']} />
          <PrivateRoute path="/Calendario" component={Calendario} roles={['farmAdmin']}/>
          <PrivateRoute path="/Productos" component={Productos} roles={['warehouse', 'warehouseAdmin', 'farmAdmin', 'productPurchase']}/>
          <PrivateRoute path="/Herramientas" component={Herramientas} roles={['warehouse', 'warehouseAdmin', 'farmAdmin', 'productPurchase']}/>
          <PrivateRoute path="/Pisca" component={Pisca} roles={['farmAdmin','office']} />
          <PrivateRoute path="/Tele" component={PTele} roles={['todos']} />
          <PrivateRoute path="/Pagos" component={Pagos} roles={['office', 'farmAdmin']} />
          <PrivateRoute path="/Test" component={Test} />
          <PrivateRoute path="/Vales" component={Vales} />
          <PrivateRoute path="/perfil" component={UserPage} roles={['todos']}/>
          <PrivateRoute path="/ajustes" component={Ajustes} roles={['admin']}/>
          <Route component={NotFound} />
        </Switch>
        <AdminAssistant />
      </Router>
    </div>
  </AuthProvider>
  );
}

export default App;
